import styled from "styled-components";

import { Row } from "./Row";

export const BodyRow = styled(Row)``;
